import Swal from "sweetalert2";

const CustomAlert = ({ icon, confirmButtonText, onConfirm, title }) => {
  return Swal.fire({
    title: title,
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: confirmButtonText,
    cancelButtonText: "Cancel",
    confirmButtonColor: "#88bd42",
    cancelButtonColor: "#222",
    icon: icon,
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
};
export default CustomAlert;
